<main>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'BankTransaction_Title' | translateWF: 'Bank Transactions' }}</h1>
        <div class="page__title_buttons">
          <p-speedDial [model]="speedDialItems" direction="left" [transitionDelay]="80">
            <ng-template #button let-toggleCallback="toggleCallback">
              <p-button (click)="toggleCallback($event)" [label]="'Add' | translateWF: 'Add'" icon="pi pi-plus" />
            </ng-template>
            <ng-template #item let-item let-toggleCallback="toggleCallback">
              <p-button variant="outlined" severity="secondary" (click)="toggleCallback($event, item)" [label]="item.label" [icon]="item.icon" />
            </ng-template>
          </p-speedDial>
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      <p-table
        *ngIf="transactions() && transactions()!.length > 0"
        [value]="transactions()!"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[5, 10, 20]"
        selectionMode="single"
        styleClass="p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'BankTransaction_Table_Number' | translateWF: 'Number' }}</th>
            <th>{{ 'BankTransaction_Table_Date' | translateWF: 'Transaction Date' }}</th>
            <th>{{ 'BankTransaction_Table_Type' | translateWF: 'Type' }}</th>
            <th>{{ 'BankTransaction_Table_Concept' | translateWF: 'Concept' }}</th>
            <th>{{ 'BankTransaction_Table_From' | translateWF: 'From' }}</th>
            <th>{{ 'BankTransaction_Table_To' | translateWF: 'To' }}</th>
            <th>{{ 'BankTransaction_Table_Amount' | translateWF: 'Amount' }}</th>
            <th>{{ 'BankTransaction_Table_Currency' | translateWF: 'Currency' }}</th>
            <th>{{ 'BankTransaction_Table_Status' | translateWF: 'Status' }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-tx>
          <tr class="cursor-pointer" (click)="redirectToDetails(tx.id)">
            <td>
              <a>{{ tx.number }}</a>
            </td>
            <td>{{ tx.transactionDate | date: 'dd/MM/yyyy' }}</td>
            <td>
              <p-tag [severity]="movementSeverity(tx.financialTransactionType)" [value]="movementLabel(tx.financialTransactionType)" />
            </td>
            <td>{{ tx.concept }}</td>
            <td>{{ tx.from?.code }}</td>
            <td>{{ tx.to?.code }}</td>
            <td>{{ tx.from?.amount ?? tx.to?.amount | number: '1.2-2' }}</td>
            <td>{{ currencyLabel(tx.from?.currency ?? tx.to?.currency) }}</td>
            <td>
              <p-tag [severity]="statusSeverity(tx.status)" [value]="statusLabel(tx.status)" />
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</main>
